import { signOut } from "firebase/auth";
import { getFirebaseAuth } from "../../firebase/firebaseService";
import { getAuthConfig } from "../../config/AuthConfigContext";
import { clearBearerToken } from "../../services/bearerToken";
import { clearMemberManagementToken } from "../../services/memberManagementService";
import { UserStore } from "../../store/userGeneralInfoStore";
import { logError } from "../../utils/customLogger";
import { logOutError } from "../authSlice";
import { resetAllAppStates } from "./resetAllStateThunk";
import type { AuthAppDispatch } from "../store";

export const logOutUserFromFirebase =
  () => async (dispatch: AuthAppDispatch) => {
    try {
      const config = getAuthConfig();
      config?.analytics?.clearUser?.();

      clearBearerToken();
      clearMemberManagementToken();

      await signOut(getFirebaseAuth());
      clearDataFromStorage();
      dispatch(resetAllAppStates());
    } catch (error) {
      logError(error as Error, "Error during sign out");
      if (error instanceof Error) {
        dispatch(logOutError(error.message));
      } else {
        dispatch(logOutError("An unknown error occurred during logout."));
      }
    }
  };

export const clearDataFromStorage = () => {
  try {
    localStorage.clear();
    UserStore.clearAll();
    sessionStorage.clear();
  } catch (error) {
    logError(error as Error, "Error clearing localStorage and sessionStorage");
  }
};
